





















































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import {Customer} from "@/entity/Customer";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {CustomerDto} from "@/dto/CustomerDto";
import {getModule} from "vuex-module-decorators";
import {CustomerStore} from "@/store/CustomerStore";
import CustomerAdminTable from "@/views/KeShangAdmin/CustomerAdminTable.vue";
import KeShangMain from "@/views/KeShangMain.vue";
import {AuthStore} from "@/oauth/AuthStore";
import {Pagination} from "pansx-utils/src/index";
import {AuthTokenDto} from "@/oauth/AuthTokenDto";
import {CollectCompany} from "@/entity/CollectCompany";
import {CollectCompanyDto} from "@/dto/CollectCompanyDto";
import {User} from "@/oauth/User";
import XXHeader from "@/views/KeShangAdmin/XXHeader.vue";
import {AppUpdateVersionDto} from "@/dto/AppUpdateVersionDto";
import {AppUpdateVersion} from "@/entity/AppUpdateVersion";
import {RealTimeInfo} from "@/entity/RealTimeInfo";
import {TimeAssistant} from "@/entity/TimeAssistant";
import {TimeAssistantDto} from "@/dto/TimeAssistantDto";
import {TimeAssistantAttachmentDto} from "@/dto/TimeAssistantAttachmentDto";
import {TimeAssistantAttachment} from "@/entity/TimeAssistantAttachment";
import {UserDto} from "@/oauth/UserDto";
import {XmppUtils} from "@/xmpp/XmppUtils";
import {RealTimeInfoStore} from "@/store/RealTimeInfoStore";
import {RealTimeInfoReqDto} from "@/dto/RealTimeInfoReqDto";
import {UserInfoEntity} from "@/entity/UserInfoEntity";
import {UserInfoEntityDto} from "@/dto/UserInfoEntityDto";
import RealTimeInfoReq from "@/dto/RealTimeInfoReq";
import {TimeAssistantCollaborator} from "@/entity/TimeAssistantCollaborator";
import {TimeAssistantCollaboratorDto} from "@/dto/TimeAssistantCollaboratorDto";
import {CompanyInfo} from "@/entity/CompanyInfo";


@Component({
  components: {XXHeader, CustomerAdminTable, KeShangMain},
})

export default class KeShangSelect extends Vue {
  public demo: RealTimeInfo[] = [];
  private customers: Customer[] = [];
  customer = new Customer();
  isAdminOpen = false;
  cs = getModule(CustomerStore);
  ls = getModule(AuthStore);
  su = SecurityUtils;
  rightDrawerOpen = true;
  drawer = false;
  tab = 'home';
  user = new User();
// tabs=["group_add","home","mails"]
  collectCompany = new CollectCompany();
  items = ([{}, {}, {}, {}, {}, {}, {}, {}, {}]);
  infoDialog = false;
  infoUrl = '';
  date = KeShangSelect.formatDate(Date.parse(new Date().toString()));
  events: string[] = [];
  splitterModel = -50;
  splitterModel1 = 0;


  static thisMachineAppVersionCode = 15;
  thisMachineAppVersionCode = 15; //本机的版本代号
  versionDialog = false;
  thisMachineAppVersion = new AppUpdateVersion();//存放版本信息
  zihun = 'star'
  timeAssistants: TimeAssistant[] = [];
  timeAssistantAttachment: TimeAssistantAttachment[] = [];
  timeAssistants1: TimeAssistant[] = [];//协作日程
  timeAssistantFriends = XmppUtils.friends;

  get timeAssistantss() {
    const timeAssistants: TimeAssistant[] = [];
    this.timeAssistants.forEach(value => {
      if (value.startDate.substring(0, 10) == this.date)
        timeAssistants.push(value);
    })
    return timeAssistants;
  }

  async findTimeAssistantAttachment(id: number) {
    this.timeAssistantAttachment = [];
    const timeAssistantAttachment = new TimeAssistantAttachment();
    timeAssistantAttachment.timeAssistantId = id;
    this.timeAssistantAttachment = await TimeAssistantAttachmentDto.findAll(timeAssistantAttachment);
  }

  gotToRealInfoMore() {
    this.$router.push({name: 'RealTimeInfoList'});
  }

  initRealInfo(val: string) {
    console.log('---');
    this.zihun = val
    this.handleRealInfo(val, '')
    this.getTimeAssistant()
  }

  async findTimeAssistantsFriends() {
    this.timeAssistantFriends.forEach(value => value.createCollaborator = false);
    for (const value of this.timeAssistants1) {
      if (value.startDate.substring(0, 10) === this.date) {
        const user = await UserDto.findById(value.id as number);
        this.timeAssistantFriends.forEach(value1 => {
          if (value1.jid.substring(0, 11) === user.username) {
            value1.createCollaborator = true;
            value1.timeAssistantId = value.id as number;
          }
        })
      }
    }
  }

  openInfo(realInfo: RealTimeInfo) {
    // this.infoUrl = realInfo.infoUrl
    // this.infoDialog = true
    this.$router.push(
        '/RealTimeInfoView/' + realInfo.id
    );
  }

  // async findAllRealInfo() {
  //   this.realInfos = await RealTimeInfoDto.findAll()
  // }

  ccccc() {
    console.log(1)
    window.parent.postMessage('调用高德地图' + "," + 120.548682 + "," + 39.966577 + "," + "南丰镇", '*')
  }

  cc() {
    window.parent.postMessage('调用高德地图' + "," + "120.548682" + "," + "39.966577" + "," + "南丰镇", '*')
  }


  // TEST(){
  // console.log("111")
  // window.parent.postMessage("回聊天","http://192.168.99.133:8080")
  // console.log("111")
  // window.parent.postMessage('调用百度地图'+","+31.971566+","+120.548682+","+"南丰镇", '*')
  // console.log(178945);
  // window.location.href = "iOSTencentTest://yzks.yong-gang.cn/#/chatPage/13739160665@rtc1,%E5%AD%99%E5%87%AF"
  // window.parent.location.href="https://yzks.yong-gang.cn/#/chatPage/13739160665@rtc1,%E5%AD%99%E5%87%AF"
  // }
  // get realInfos() {
  //   return getModule(RealTimeInfoStore).realInfos
  // }

  // @Watch('realInfos', {
  //   immediate: true,
  //   deep: true
  // })
  // async changeRealInfos(newVal: RealTimeInfo[]) {
  //   console.log('new:'+newVal)
  //     this.demo = newVal
  // }
  // get userInfoApps(){
  //   return getModule(RealTimeInfoStore).queryInfo;
  // }
  // @Watch('userInfoApps',{
  //   immediate: true,
  //   deep: true
  // })
  // async changeUserInfoApps(newVal: UserInfoEntity){
  //   this.zihun='star'
  //   await this.handleRealInfo('star','')
  // }


  hrefClick() {
    window.location.href = this.thisMachineAppVersion.appUrl;//当前标签页
    // console.log(this.thisMachineAppVersion.appUrl);
    // console.log(this.thisMachineAppVersion);
    // window.open(this.thisMachineAppVersion.appUrl);//打开一个新的标签页
    // window.open("https://ksdl.yong-gang.cn/code/getOne")  ios端
  }

  colseVersionInformation() {
    this.versionDialog = false
  }

  async refresh() {
    setTimeout(() => {
      location.reload();
      // this.$router.push({name: 'refresh'})
    }, 1000)
  }

  // appId =  this.collectCompany.customerAppId

  public readonly pagination!: Pagination;

  async getById(id = this.id) {
    this.customer = await CustomerDto.findById(Number(id));
    // this.customer.businessLicense = "http://ygpubfile.yong-gang.cn:80/f/23e8b94d-0643-4533-870e-e93fe424a7ad.jpg";
  }


  keShangSelect() {
    // if (this.customer.isReviewPass) {
    this.goToQingAppList(this.customer.id);
    // }


    // }else {
    //   this.$router.replace({name:'PreviewNotPass'});
    //   this.$q.notify({message: '您的公司在审核中,无法使用轻应用', type: 'negative'});
    // }

  }

  keShangSelect1() {
    this.$router.push({name: 'keShangSelect1'});
  }

  keShangSelect2() {
    this.$router.push({name: 'keShangSelect2'});
  }


  async save(d: Customer) {
    try {
      await CustomerDto.save(d);
      this.$q.notify('保存成功!');
    } catch (e) {
      this.$q.notify({message: '错误:' + e, color: 'red'});
    }
  }

  public get columns() {
    let columns = Customer.getColumns();
    columns.push({
      label: ' ',
      name: 'edit',
      field: '',
    });
    columns = columns.filter(value => !['creatorId', 'isReviewPass'].some(s => value.name === s));
    return columns;
  }

///
  async getId(id = this.id) {
    this.customer = await CustomerDto.findById(Number(id));
  }

  goToZiZhangHaoGuanLi() {
    this.$router.push({name: 'ZiZhangHao'});
  }

  get id() {
    return this.$route.params.id as string;
  }

  get currentName() {
    // return this.cs.currentCustomer.name;
    return this.collectCompany.companyName;
  }

  get Name() {
    return this.collectCompany.companyName;
  }

  get appId() {
    return this.collectCompany.customerAppId
  }

  // saveCompany() {
  //   localStorage.setItem("name", this.cs.currentCustomer.name)
  // }

  // companyName() {
  //   const item: string | null = localStorage.getItem("name");
  //   if (item == null) {
  //     return "home"
  //   }
  //   return item;
  // }

  async existIdentity() {
    const userInfoEntity = new UserInfoEntity()
    userInfoEntity.userName = this.su.getLoginUser().username
    const identity = await UserInfoEntityDto.selectCompanyInfo(userInfoEntity)
    if (identity != null && identity.length > 0) {
      return true;
    }
    return false;
  }

  async getTimeAssistant() {
    const timeAssistantCollaborator1 = new TimeAssistantCollaborator();
    timeAssistantCollaborator1.username = this.su.getLoginUser().username;
    const timeAssistantCollaborators = await TimeAssistantCollaboratorDto.findAll(timeAssistantCollaborator1);//全部协作日程
    for (const value of timeAssistantCollaborators) {
      const timeAssistant = await TimeAssistantDto.findById(value.timeAssistantId);
      this.timeAssistants.push(timeAssistant);
    }
  }
  async handleRealInfo(newVal: string, oldVal: string) {
    this.demo = []
    console.log('-----' + newVal)
    const realTimeInfoReq: RealTimeInfoReq = new RealTimeInfoReq();
    const type = realTimeInfoReq.getRealInfoType(newVal);
    if (type != undefined) {
      realTimeInfoReq.infoType = type;
      // const demo1: UserInfoEntity = JSON.parse(localStorage.getItem('demo1') as string);
      const companyInfo = JSON.parse(localStorage.getItem("selectedCompanyInfo") as  any) as CompanyInfo;
      if (await this.existIdentity()) {
        realTimeInfoReq.userName = this.su.getLoginUser().username;
        realTimeInfoReq.companyId = companyInfo.companyId;
      } else {
        realTimeInfoReq.userName = this.su.getLoginUser().username;
      }
      const page: RealTimeInfoReq = await RealTimeInfoReqDto.queryRealList(realTimeInfoReq);
      const newsList = page.content;
      newsList.sort((o1, o2) => {
        return (o2.infoReadTime as number) - (o1.infoReadTime as number)
      })
      console.log("end:" + newsList);
      this.demo = newsList;
      localStorage.setItem("infoReal", JSON.stringify({"infoType": type, "size": this.demo.length}));
      await getModule(RealTimeInfoStore).setCurrentRealInfos(newsList);
    }
  }


  get userName() {
    return this.ls.loginUser.username
  }

  suc() {
    AuthTokenDto.logout();
    this.$router.push({name: 'login'});
  }


  toggleRightDrawer() {
    this.rightDrawerOpen = !this.rightDrawerOpen;
  }


  async findAll() {
    const id = this.su.getLoginUser().id as number;
    const customer = new Customer();
    customer.creatorId = id;
    this.customers = await CustomerDto.findAll(customer);
    for (const value of this.su.getLoginUser().authorities) {
      if (value.authority.startsWith('ROLE_CUSTOMER_')) {
        const id = Number(value.authority.replace('ROLE_CUSTOMER_', '').replace('_ADMIN', ''));
        if (!this.customers.some(c => c.id === id)) {
          const customer = await CustomerDto.findById(id);
          if (typeof customer !== 'undefined') {
            this.customers.push(customer);
          }
        }
      }
    }
  }

  async findAllCompanyName() {
    // const  id = this.su.getLoginUser().id as number;
    // const  collectName = new  CollectCompany()
    // collectName.userId = id;
    // this.collectCompanys = await  CollectCompanyDto.findAll(collectName)
    // console.log(this.collectCompanys)
    // return this.collectCompanys.push(this.collectCompany)

    // const  collectName = await CollectCompanyDto.findById(id)
    const id = this.su.getLoginUser().id as number;
    // const  appid = this.collectCompany.customerAppId as  number;
    // const  collectName = new  CollectCompany();
    this.collectCompany = await CollectCompanyDto.findById(id)

    const aa = this.collectCompany.customerAppId as number;

    this.goQingAppList(aa);
    // console.log(this.collectCompany)
    // this.collectCompany.companyName = this.module.currentCustomer.name
  }

  // suc() {
  //   AuthTokenDto.logout();
  //   this.$router.push({name: 'login'});
  // }


// async collectName(){
//
//     const name: Customer = await CustomerDto.findByName("中石油")
//     console.log(name)
//     // this.module.setCurrentCustomer(name)
//     // console.log(this.module.setCurrentCustomer(name))
//
//     // this.goToQingAppList(this.module.currentCustomer.id)
//   this.handleClick(name)
// }


  private module: CustomerStore = getModule(CustomerStore);

  handleClick(c: Customer) {
    // getModule(CustomerStore).setCurrentCustomer(c);
    this.module.setCurrentCustomer(c);

    // this.collectCompany.userId =
    this.collectCompany = new CollectCompany()
    this.collectCompany.userName = this.ls.loginUser.username
    // console.log(this.collectCompany.userName)
    this.collectCompany.userId = this.ls.loginUser.id
    this.collectCompany.companyName = c.name
    this.collectCompany.customerAppId = c.id
    this.collectCompany.isReviewPass = c.isReviewPass
    CollectCompanyDto.save(this.collectCompany)

    this.rightDrawerOpen = !this.rightDrawerOpen;

    // this.saveCompany();
    //const id = c.id + '';
    //this.$router.push({name: 'KeShangMain', params: {id: id}});
    if (c.isReviewPass) {
      // console.log(c.id)
      this.goToQingAppList(c.id);
    } else {
      this.$router.replace({name: 'PreviewNotPass'});
      // this.$q.notify({message: '您的公司在审核中,无法使用轻应用', type: 'negative'});
    }

  }

  async goToQingAppList(item: string | number | null = localStorage.getItem('currentCustomerId')) {
    const id = Number(item);
    // if (this.$route.name === 'QingAppList') {
    //   await this.$router.push('/');
    // }
    if (this.customers.some(value => Number(value.id) === id)) {
      if (this.$route.params.id !== item) {
        await this.$router.replace({name: 'QingAppList', params: {id: id + ''}});
      }
    } else if (this.customers.length > 0) {
      await this.$router.replace({name: 'QingAppList', params: {id: this.customers[0].id + ''}});
    } else {
      // this.$q.notify({message: '您没有所属的客商,无法使用轻应用', type: 'negative'});
      console.log('-')
    }
  }

  async goQingAppList(ids: number) {
    const id = this.su.getLoginUser().id as number;
    this.collectCompany = await CollectCompanyDto.findById(id)

    if (this.collectCompany.isReviewPass) {
      await this.$router.replace({name: 'QingAppList', params: {id: ids + ''}});
    } else {
      // this.$q.notify({message: '您没有所属的客商,无法使用轻应用', type: 'negative'});
      console.log('-')
    }
  }

  async goQingAppList1() {
    // const id = this.su.getLoginUser().id as number;
    // this.collectCompany = await CollectCompanyDto.findById(id)

    // if (this.collectCompany.isReviewPass) {
    await this.$router.replace({name: 'QingAppList', params: {id: 1 + ''}});
    // } else {
    //   this.$q.notify({message: '您没有所属的客商,无法使用轻应用', type: 'negative'});
    // }
  }

  async checkThisVersionForUpdates() {
    localStorage.setItem("version", this.thisMachineAppVersionCode.toString())
    const win: any = window;
    const webkit = win.webkit;
    const ua = navigator.userAgent.toLowerCase();
    //android终端
    const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
    //ios终端
    const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      //ios
      try {
        console.log("ios")
        const appleVersion = new AppUpdateVersion()
        appleVersion.appSystem = '1'
        const a = await AppUpdateVersionDto.findLastAppSystemInformation(appleVersion)
        const versionInformationFlag = sessionStorage.getItem("versionInformationFlag")
        if ((this.thisMachineAppVersionCode < a.appVersionCode) && versionInformationFlag === null) {
          this.thisMachineAppVersion = a
          this.versionDialog = true
          sessionStorage.setItem("versionInformationFlag", '1')
        }
      } catch (e) {
        this.$q.notify("Apple暂时无数据更新")
      }
    } else if (/(Android)/i.test(navigator.userAgent)) {
      //android
      try {
        console.log("android")
        const appleVersion = new AppUpdateVersion()
        appleVersion.appSystem = '0'
        const a = await AppUpdateVersionDto.findLastAppSystemInformation(appleVersion)
        const versionInformationFlag = sessionStorage.getItem("versionInformationFlag")
        if ((this.thisMachineAppVersionCode < a.appVersionCode) && versionInformationFlag === null) {
          this.thisMachineAppVersion = a
          this.versionDialog = true
          sessionStorage.setItem("versionInformationFlag", '1')
        }
      } catch (e) {
        this.$q.notify("Android暂时无数据更新")
      }
    }
    // const appUpdateVersions = await AppUpdateVersionDto.findAll(new AppUpdateVersion());
    // const appUpdateVersion = appUpdateVersions[appUpdateVersions.length - 1];
    // const versionInformationFlag = sessionStorage.getItem("versionInformationFlag")
    // // console.log(appUpdateVersion)
    // if ((this.thisMachineAppVersionCode < appUpdateVersion.appVersionCode) && versionInformationFlag === null) {
    //   this.thisMachineAppVersion = appUpdateVersion
    //   this.versionDialog = true
    //   sessionStorage.setItem("versionInformationFlag", '1')
    // }
  }

  static formatDate(timeStamp: number) {
    //三目运算符
    const Dates = new Date(timeStamp);
    //年份
    const Year: number = Dates.getFullYear();
    //月份下标是0-11
    const Months: any = (Dates.getMonth() + 1) < 10 ? '0' + (Dates.getMonth() + 1) : (Dates.getMonth() + 1);
    //具体的天数
    const Day: any = Dates.getDate() < 10 ? '0' + Dates.getDate() : Dates.getDate();
    //小时
    const Hours = Dates.getHours() < 10 ? '0' + Dates.getHours() : Dates.getHours();
    //分钟
    const Minutes = Dates.getMinutes() < 10 ? '0' + Dates.getMinutes() : Dates.getMinutes();
    //秒
    const Seconds = Dates.getSeconds() < 10 ? '0' + Dates.getSeconds() : Dates.getSeconds();
    //返回数据格式
    return Year + '/' + Months + '/' + Day;
  }

  // async flushPage() {
  //   const a = await AuthTokenDto.flushPage(this.ls.loginUser.username)
  // }


  private async mounted() {
    // this.findAll().then(value => {
    //   this.tab = this.companyName();
    //   const find = this.customers.find(c => c.name === this.tab);
    //   if (find !== undefined) {
    //     this.handleClick(find);''
    //
    //   }
    //   this.tab = 'home';
    // });
    // return;
    // await this.flushPage()
    await this.findAll();
    // this.findAllCompanyName();
    await this.checkThisVersionForUpdates();
    await this.goQingAppList1()

    // const timeAssistant = new TimeAssistant();
    // timeAssistant.username = this.su.getLoginUser().username;
    // this.timeAssistants = await TimeAssistantDto.findAll(timeAssistant);//自己所有的日程
    // const timeAssistant1 = new TimeAssistant();
    // timeAssistant1.username = this.su.getLoginUser().username;
    //
    // this.timeAssistants1 = await TimeAssistantDto.findAll(timeAssistant1);//所有自己创建的日程
    this.timeAssistants.forEach(value => {
      // if (value.startDate.substring(0, 10) == KeShangSelect.formatDate(Date.parse(new Date().toString()))) {
      //   this.findTimeAssistantAttachment(value.id as number);
      // }
      this.events.push(value.startDate.substring(0, 10));
    });
    // await this.findTimeAssistantsFriends();
    // this.collectName()

    document.addEventListener("backbutton", evt => {
      // console.log(this.$route.name)
      // console.log(this.$route.path)
      // console.log(this.$route.fullPath)
      if (this.$route.name === "QingAppList") {
        // console.log(evt);
        const win: any = window;
        // window.navigator.app.exitApp();
        win.navigator.app.exitApp();
      }
    })
    if (XmppUtils.friends.length == 0) {
      const friendList = window.localStorage.getItem("friendList");
      if (friendList !== null) {
        XmppUtils.friends = JSON.parse(friendList)
      }
    }

    // console.log(this.collectCompany.customerAppId)

    //  if(this.collectCompany.isReviewPass) {
    // console.log(this.collectCompany.isReviewPass)
    //    this.goToQingAppList(this.collectCompany.customerAppId);
    //  }else{
    //    this.$router.replace({name:'PreviewNotPass'});
    //    this.$q.notify({message: '您的公司在审核中,无法使用轻应用', type: 'negative'});
    //  }

    // this.goToQingAppList(46)


    // this.goQingAppList(this.appId);

    // this.findAllRealInfo()


  }

}
